// export const AppVersion = "v0.0.1";

// // const HOST = "LOCAL";
// const HOST = "DEVELOPMENT";
// // const HOST = "TEST";
// // const HOST = "PRODUCTION";

// //main url
// const URL =
//   App_Host == "LOCAL"
//     ? "http://20.213.22.89"
//     : App_Host == "TEST"
//     ? "Sandbox.am8.au"
//     : App_Host == "DEVELOPMENT"
//     ? "develop.am8.au"
//     : App_Host == "PRODUCTION"
//     ? "Login.am8.com.au"
//     : "";

//   //file url
// const Fileurl =
//   HOST === "LOCAL"
//     ? ""
//     : HOST === "DEVELOPMENT"
//     ? "https://dsetting.am8.au/public"
//     : HOST === "TEST"
//     ? "https://bsetting.am8.au/public"
//     : HOST === "PRODUCTION"
//     ? "https://setting.am8.com.au/public"
//     : "";

// //base url
// const UserService =
//   App_Host == "LOCAL"
//     ? ":8000"
//     : App_Host == "TEST"
//     ? "buser.am8.au"
//     : App_Host == "DEVELOPMENT"
//     ? "duser.am8.au"
//     : App_Host == "PRODUCTION"
//     ? "user.am8.com.au"
//     : "";
// const SettingService =
//   App_Host == "LOCAL"
//     ? "bsetting.am8.au"
//     : App_Host == "TEST"
//     ? "dsetting.am8.au"
//     : App_Host == "DEVELOPMENT"
//     ? "setting.am8.com.au"
//     : App_Host == "PRODUCTION"
//     ? ""
//     : "";
// const WorkService =
//   App_Host == "LOCAL"
//     ? ""
//     : App_Host == "TEST"
//     ? "bwork.am8.au"
//     : App_Host == "DEVELOPMENT"
//     ? "dwork.am8.au"
//     : App_Host == "PRODUCTION"
//     ? "work.am8.com.au"
//     : "";
// const ReportService =
//   App_Host == "LOCAL"
//     ? ""
//     : App_Host == "TEST"
//     ? "breport.am8.au"
//     : App_Host == "DEVELOPMENT"
//     ? "dreport.am8.au"
//     : App_Host == "PRODUCTION"
//     ? "report.am8.com.au"
//     : "";
// const PayRollService =
//   App_Host == "LOCAL"
//     ? ""
//     : App_Host == "TEST"
//     ? ""
//     : App_Host == "DEVELOPMENT"
//     ? ""
//     : App_Host == "PRODUCTION"
//     ? ""
//     : "";

// const APP_URL = {
//   User: User,
//   Setting: Setting,
//   Work: Work,
//   Report: Report,
//   PayRoll: PayRoll,
// };

// export { HOST, URL, APP_URL, Fileurl };

export const AppVersion = "v0.0.1";

// const HOST = "LOCAL";
// const HOST = "DEVELOPMENT";
// const HOST = "TEST";
const HOST = "PRODUCTION";

//main url
const URL =
  HOST === "LOCAL"
    ? ""
    : HOST === "DEVELOPMENT"
    ? "https://develop.am8.au"
    : HOST === "TEST"
    ? "https://Sandbox.am8.au"
    : HOST === "PRODUCTION"
    ? "https://Login.am8.com.au"
    : "";

//file url
const Fileurl =
  HOST === "LOCAL"
    ? ""
    : HOST === "DEVELOPMENT"
    ? "https://dsetting.am8.au/public"
    : HOST === "TEST"
    ? "https://bsetting.am8.au/public"
    : HOST === "PRODUCTION"
    ? "https://setting.am8.com.au/public"
    : "";

//base url
let User =
  HOST === "LOCAL"
    ? ""
    : HOST === "DEVELOPMENT"
    ? "https://duser.am8.au"
    : HOST === "TEST"
    ? "https://buser.am8.au"
    : HOST === "PRODUCTION"
    ? "https://user.am8.com.au"
    : "";
const Setting =
  HOST === "LOCAL"
    ? ""
    : HOST === "DEVELOPMENT"
    ? "https://dsetting.am8.au"
    : HOST === "TEST"
    ? "https://bsetting.am8.au"
    : HOST === "PRODUCTION"
    ? "https://setting.am8.com.au"
    : "";
const Work =
  HOST === "LOCAL"
    ? ""
    : HOST === "DEVELOPMENT"
    ? "https://dwork.am8.au"
    : HOST === "TEST"
    ? "https://bwork.am8.au"
    : HOST === "PRODUCTION"
    ? "https://work.am8.com.au"
    : "";
const Report =
  HOST === "LOCAL"
    ? ""
    : HOST === "DEVELOPMENT"
    ? "https://dreport.am8.au"
    : HOST === "TEST"
    ? "https://breport.am8.au"
    : HOST === "PRODUCTION"
    ? "https://report.am8.com.au"
    : "";
const PayRoll =
  HOST === "LOCAL"
    ? ""
    : HOST === "DEVELOPMENT"
    ? "https://dpayroll.am8.au"
    : HOST === "TEST"
    ? "https://bpayroll.am8.au"
    : HOST === "PRODUCTION"
    ? "https://payroll.am8.com.au"
    : "";

const APP_URL = {
  User: User,
  Setting: Setting,
  Work: Work,
  Report: Report,
  PayRoll: PayRoll,
};

export { HOST, URL, APP_URL, Fileurl };
